module.exports = __webpack_public_path__ + "static/logo-vanessa-manper-0876de4dba929e7564584674d5f52c96.png";